import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <h2 className='footer-title'>Questions?</h2>
      <p>Call or text us:</p>
      <p>Thai: +1 (267) 221-2876</p>
      <p>Coleen: +1 (617) 991-0239</p>
    </footer>
  );
}

export default Footer;
